/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const patchedValidationWorkflowUpdateRequestNameMax = 256;

export const patchedValidationWorkflowUpdateRequestDescriptionMax = 1024;

export const PatchedValidationWorkflowUpdateRequest = zod.strictObject({
    name: zod
        .string()
        .min(1)
        .max(patchedValidationWorkflowUpdateRequestNameMax)
        .optional(),
    description: zod
        .string()
        .max(patchedValidationWorkflowUpdateRequestDescriptionMax)
        .optional(),
    forms: zod.array(zod.number()).optional(),
});

export type PatchedValidationWorkflowUpdateRequest = zod.input<
    typeof PatchedValidationWorkflowUpdateRequest
>;
export type PatchedValidationWorkflowUpdateRequestOutput = zod.output<
    typeof PatchedValidationWorkflowUpdateRequest
>;
